export default __webpack_public_path__ + "static/media/image-mobile.9b9c4cc4.png";